import {
	Component,
	OnInit,
	AfterViewInit,
	ChangeDetectorRef,
	ViewChild,
	ElementRef
} from "@angular/core";
import { Router } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { GlobalService } from "../../../services/global/global.service";
import { Observable } from "rxjs";
import { DMVStoreService } from "../../../services/dmv/dmv-store.service";
import { AgencyDmvConfigResponse } from "src/app/models/dmv/agency-config.response";
import { MailingAddress } from "src/app/models/dmv/mailingAddress";
import { Registration } from "src/app/models/dmv/registration";
import { AppUtil } from "../../../utils/app.util";
import { MEGStoreService } from "src/app/services/meg/meg-store.service";
import { CountryRegions } from "src/app/models/dmv/countryRegions";
import { CountryCodes } from "src/app/models/dmv/models";
import { Countries } from "src/app/models/dmv/countries";
@Component({
	selector: "app-pickup-mailing",
	templateUrl: "./pickup-mailing.component.html",
	styleUrls: ["./pickup-mailing.component.css"]
})
export class DmvPickupMailingComponent implements OnInit, AfterViewInit {
	constructor(
		private router: Router,
		public globalService: GlobalService,
		public dmvStoreService: DMVStoreService,
		public megStoreService: MEGStoreService,
		private formBuilder: FormBuilder,
		private cd: ChangeDetectorRef
	) {}
	@ViewChild("registrantNameEle", { static: false })
	registrantNameEle: ElementRef;
	public errorMessage: string = "";
	public agencyConfig: AgencyDmvConfigResponse;
	public isloading: boolean = false;
	public submitted: boolean = false;
	public pickupMailingForm: FormGroup;
	public mailingAddress: MailingAddress;
	public updateAddressCheckBox: boolean = false;
	public registrantName = null;
	public firstRegistration: Registration = null;
	public openConfirmModel: boolean = false;
	public mailFee: number;
	public IsmailFee: boolean;
	public countryList: Countries;
	public countryRegions: CountryRegions;
	public filteredCountryRegions: CountryRegions;
	public title: string;
	public permAddressUpdate: boolean = false;
	public tempAddressChange: boolean = false;

	ngOnInit() {
		AppUtil.log("DmvPickupMailingComponent ngOnInit() == >");
		if (
			this.globalService.params &&
			this.globalService.params.deliveryMethodID
		) {
			this.globalService.params.deliveryMethodID = null;
		}
		this.title = "Shipping Address For Registration(s) & Decal(s)";
		this.dmvStoreService.registrationsInCart.hasAddress = true;
		this.dmvStoreService.addressrequired = false;
		this.IsmailFee = false;
		this.dmvStoreService.agencyConfig$.subscribe(agencyConfig => {
			if (agencyConfig) {
				this.agencyConfig = agencyConfig;
			}
		});
		this.megStoreService.configurationsData$.subscribe(data => {
			if (data && data.megConfig) {
				this.countryRegions = data.megConfig.countryRegions;
				this.countryList = data.megConfig.countries;
			}
		});

		this.mailFee = 0;
		if (
			this.dmvStoreService.registrationsInCart.dmvRegistrations &&
			this.dmvStoreService.registrationsInCart.dmvRegistrations.length > 0
		) {
			if (this.agencyConfig.agencyDmvConfig.mailFeeModel === "MAILONLY") {
				this.IsmailFee = true;

				this.dmvStoreService.registrationsInCart.dmvRegistrations.forEach(
					DmvRegistration => {
						if (
							DmvRegistration.registration &&
							DmvRegistration.registration.dmvFees
						) {
							DmvRegistration.registration.dmvFees.forEach(dmvFee => {
								if (dmvFee.feeID === 1) {
									this.mailFee = this.mailFee + dmvFee.amount;
								}
							});
						}
					}
				);
			}
			this.firstRegistration = this.dmvStoreService.registrationsInCart.dmvRegistrations[0].registration;
		}

		if (this.dmvStoreService.registrationsInCart.mailingAddress) {
			this.mailingAddress = this.dmvStoreService.registrationsInCart.mailingAddress;
			this.updateAddressCheckBox = this.mailingAddress.updateAddressCheckBox;
			this.permAddressUpdate = this.mailingAddress.permAddressUpdate;
			this.tempAddressChange = this.mailingAddress.tempAddressChange;
		} else {
			if (this.firstRegistration) {
				this.dmvStoreService.registrationsInCart.addressComefrom = undefined;
				this.mailingAddress = Object.create(null);
				if (this.firstRegistration.registrantAddress) {
					this.mailingAddress.city = this.firstRegistration.registrantAddress.city;
					this.mailingAddress.billigAddress1 = this.firstRegistration.registrantAddress.line1;
					this.mailingAddress.billigAddress2 = this.firstRegistration.registrantAddress.line2;
					this.mailingAddress.countryCode = this.firstRegistration.registrantAddress.countryCode;
					this.mailingAddress.state = this.firstRegistration.registrantAddress.stateCode;
					this.mailingAddress.zip = this.firstRegistration.registrantAddress.postalCode;
				}
				this.mailingAddress.registrantName = this.firstRegistration
					.registrantName
					? this.firstRegistration.registrantName
					: "";
			}
		}
		this.renderForm();
	}
	public renderForm() {
		this.pickupMailingForm = this.formBuilder.group({
			registrantName: [
				this.mailingAddress ? this.mailingAddress.registrantName : "",
				[Validators.required, Validators.pattern(/^[^<=+>:;\/\\@\{\}\[\]?]*$/)]
			],

			billigAddress1: [
				this.mailingAddress ? this.mailingAddress.billigAddress1 : "",
				[Validators.required, Validators.pattern(/^[^<=+>:;\/\\@\{\}\[\]?]*$/)]
			],
			billigAddress2: [
				this.mailingAddress ? this.mailingAddress.billigAddress2 : "",
				[Validators.pattern(/^[^<=+>:;\/\\@\{\}\[\]?]*$/)]
			],
			city: [
				this.mailingAddress ? this.mailingAddress.city : "",
				[Validators.required, Validators.pattern(/^[^<=+>:;\/\\@\{\}\[\]?]*$/)]
			],
			country: [
				this.mailingAddress && this.mailingAddress.countryCode
					? this.mailingAddress.countryCode
					: "",
				Validators.required
			],
			state: [
				this.mailingAddress ? this.mailingAddress.state : "",
				Validators.required
			],
			zip: [
				this.mailingAddress ? this.mailingAddress.zip : "",
				[Validators.required, Validators.pattern(/^[^<=+>:;\/\\@\{\}\[\]?]*$/)]
			],
			updateAddress: [
				this.mailingAddress ? this.mailingAddress.updateAddress : ""
			],
			notUpdateAddress: [
				this.mailingAddress ? !this.mailingAddress.updateAddress : ""
			]
			// ,
			// phoneNumber: [
			// 	this.mailingAddress ? this.mailingAddress.phoneNumber : "",
			// 	Validators.required
			// ]
		});

		const countries = this.countryList.filter(item => {
			if (this.mailingAddress && this.mailingAddress.countryCode) {
				return item.countryCode === this.mailingAddress.countryCode;
			}
			return false;
		});
		const stateCode = this.countryRegions.filter(item => {
			if (this.mailingAddress && this.mailingAddress.state) {
				return item.regionCode === this.mailingAddress.state;
			}
			return false;
		});
		if (stateCode && stateCode.length === 0) {
			this.pickupMailingForm.controls.state.setValue("");
		}
		if (countries && countries.length === 0) {
			this.pickupMailingForm.controls.country.setValue("");
		}
		this.filteredCountryRegions = this.countryRegions.filter(item => {
			return item.countryCode === this.pickupMailingForm.controls.country.value;
		});
	}
	ngAfterViewInit() {
		setTimeout(() => {
			const inp = this.registrantNameEle.nativeElement;
			if (inp.createTextRange) {
				const part = inp.createTextRange();
				part.move("character", 0);
				part.select();
			} else if (inp.setSelectionRange) {
				inp.setSelectionRange(0, 0);
			}
			inp.focus();
		});
	}

	public updateState() {
		this.pickupMailingForm.controls.state.setValue("");
		this.filteredCountryRegions = this.countryRegions.filter(item => {
			return item.countryCode === this.pickupMailingForm.controls.country.value;
		});
	}
	public setDownIcon(event) {
		if (
			event.target &&
			event.target.offsetParent &&
			event.target.offsetParent.classList
		) {
			event.target.offsetParent.classList.remove("upArrow");
		}
	}
	public selectChangeByKey(event) {
		if (event.code === "Enter" || event.code === "Space") {
			this.selectChange(event);
		}
	}
	public selectChange(event) {
		if (
			event.target &&
			event.target.offsetParent &&
			event.target.offsetParent.classList
		) {
			if (!event.target.offsetParent.classList.contains("upArrow")) {
				event.target.offsetParent.classList.add("upArrow");
			} else {
				event.target.offsetParent.classList.remove("upArrow");
			}
		}
	}

	public get f() {
		return this.pickupMailingForm.controls;
	}
	public forgetItConfirm() {
		this.discardAddress();
		this.renderForm();
		this.openConfirmModel = false;
		this.updateAddressCheckBox = false;
		this.permAddressUpdate = false;
		this.tempAddressChange = false;
	}
	public noConfirm() {
		if (
			this.dmvStoreService.agencyConfig.agencyDmvConfig
				.allowMailingToTempAddress &&
			this.dmvStoreService.agencyConfig.agencyDmvConfig.allowAddressUpdate
		) {
			this.openConfirmModel = false;
			this.pickupMailingForm.controls.updateAddress.setValue(false);
			this.pickupMailingForm.controls.notUpdateAddress.setValue(true);
			this.updateAddressCheckBox = true;
			this.tempAddressChange = true;
		} else if (
			!this.dmvStoreService.agencyConfig.agencyDmvConfig
				.allowMailingToTempAddress &&
			this.dmvStoreService.agencyConfig.agencyDmvConfig.allowAddressUpdate
		) {
			this.discardAddress();
			this.renderForm();
			this.openConfirmModel = false;
			this.updateAddressCheckBox = false;
			this.permAddressUpdate = false;
			this.tempAddressChange = false;
		} else {
			this.discardAddress();
			this.renderForm();
			this.openConfirmModel = false;
			this.updateAddressCheckBox = false;
			this.permAddressUpdate = false;
			this.tempAddressChange = false;
		}
	}
	public yesConfirm() {
		if (
			this.dmvStoreService.agencyConfig.agencyDmvConfig
				.allowMailingToTempAddress &&
			this.dmvStoreService.agencyConfig.agencyDmvConfig.allowAddressUpdate
		) {
			this.openConfirmModel = false;
			this.pickupMailingForm.controls.updateAddress.setValue(true);
			this.pickupMailingForm.controls.notUpdateAddress.setValue(false);
			this.updateAddressCheckBox = true;
			this.permAddressUpdate = true;
		} else if (
			!this.dmvStoreService.agencyConfig.agencyDmvConfig
				.allowMailingToTempAddress &&
			this.dmvStoreService.agencyConfig.agencyDmvConfig.allowAddressUpdate
		) {
			this.openConfirmModel = false;
			this.pickupMailingForm.controls.updateAddress.setValue(true);
			this.pickupMailingForm.controls.notUpdateAddress.setValue(false);
			this.permAddressUpdate = true;
		} else {
			this.openConfirmModel = false;
			this.pickupMailingForm.controls.updateAddress.setValue(false);
			this.pickupMailingForm.controls.notUpdateAddress.setValue(true);
			this.tempAddressChange = true;
		}
	}
	public trimString(str) {
		if (str) {
			return str.trim();
		} else {
			return "";
		}
	}
	public continue() {
		AppUtil.log("DmvPickupMailingComponent continue() == >");
		this.submitted = true;
		if (this.pickupMailingForm.invalid) {
			this.errorMessage = "Please correct all errors indicated below";
			console.log("pickupMailingForm.invalid");
			return;
		}
		if (this.dmvStoreService.registrationsInCart.selectedRegistrations) {
			this.firstRegistration = this.dmvStoreService.registrationsInCart.selectedRegistrations[0];
		}
		this.mailingAddress = {};
		this.mailingAddress.registrantName = this.pickupMailingForm.controls.registrantName.value;
		this.mailingAddress.billigAddress1 = this.pickupMailingForm.controls.billigAddress1.value;
		this.mailingAddress.billigAddress2 = this.pickupMailingForm.controls
			.billigAddress2.value
			? this.pickupMailingForm.controls.billigAddress2.value
			: undefined;
		this.mailingAddress.city = this.pickupMailingForm.controls.city.value;
		this.mailingAddress.countryCode = this.pickupMailingForm.controls.country.value;
		this.mailingAddress.state = this.pickupMailingForm.controls.state.value;
		this.mailingAddress.zip = this.pickupMailingForm.controls.zip.value;
		//this.mailingAddress.phoneNumber = this.pickupMailingForm.controls.phoneNumber.value;
		this.mailingAddress.updateAddress = this.pickupMailingForm.controls.updateAddress.value;

		if (
			this.firstRegistration &&
			(this.trimString(this.mailingAddress.city) !==
				this.trimString(
					this.firstRegistration.registrantAddress &&
						this.firstRegistration.registrantAddress.city
				) ||
				this.trimString(this.mailingAddress.billigAddress1) !==
					this.trimString(
						this.firstRegistration.registrantAddress &&
							this.firstRegistration.registrantAddress.line1
					) ||
				this.trimString(this.mailingAddress.billigAddress2) !==
					this.trimString(
						this.firstRegistration.registrantAddress &&
							this.firstRegistration.registrantAddress.line2
					) ||
				this.trimString(this.mailingAddress.countryCode) !==
					this.trimString(
						this.firstRegistration.registrantAddress &&
							this.firstRegistration.registrantAddress.countryCode
					) ||
				this.trimString(this.mailingAddress.state) !==
					this.trimString(
						this.firstRegistration.registrantAddress &&
							this.firstRegistration.registrantAddress.stateCode
					) ||
				this.trimString(this.mailingAddress.zip) !==
					this.trimString(
						this.firstRegistration.registrantAddress &&
							this.firstRegistration.registrantAddress.postalCode
					))
		) {
			if (
				!(
					this.updateAddressCheckBox ||
					this.permAddressUpdate ||
					this.tempAddressChange
				)
			) {
				this.openConfirmModel = true;
				return;
			}
		} else if (!this.firstRegistration) {
			if (
				this.dmvStoreService.agencyConfig.agencyDmvConfig
					.allowMailingToTempAddress &&
				this.dmvStoreService.agencyConfig.agencyDmvConfig.allowAddressUpdate
			) {
				this.updateAddressCheckBox = true;
			} else if (
				!this.dmvStoreService.agencyConfig.agencyDmvConfig
					.allowMailingToTempAddress &&
				this.dmvStoreService.agencyConfig.agencyDmvConfig.allowAddressUpdate
			) {
				this.permAddressUpdate = true;
			} else {
				this.tempAddressChange = true;
			}
		} else {
			this.updateAddressCheckBox = false;
			this.permAddressUpdate = false;
			this.tempAddressChange = false;
			this.mailingAddress.updateAddress = false;
		}
		this.loadPage();
	}
	public discardAddress() {
		this.dmvStoreService.registrationsInCart.addressComefrom = undefined;
		if (this.dmvStoreService.registrationsInCart.selectedRegistrations) {
			this.firstRegistration = this.dmvStoreService.registrationsInCart.selectedRegistrations[0];
		}
		this.mailingAddress = Object.create(null);
		if (this.firstRegistration.registrantAddress) {
			this.mailingAddress.city = this.firstRegistration.registrantAddress.city;
			this.mailingAddress.billigAddress1 = this.firstRegistration.registrantAddress.line1;
			this.mailingAddress.billigAddress2 = this.firstRegistration.registrantAddress.line2;
			this.mailingAddress.countryCode = this.firstRegistration.registrantAddress.countryCode;
			this.mailingAddress.state = this.firstRegistration.registrantAddress.stateCode;
			this.mailingAddress.zip = this.firstRegistration.registrantAddress.postalCode;
		}
		this.mailingAddress.registrantName = this.firstRegistration.registrantName
			? this.firstRegistration.registrantName
			: "";
		this.mailingAddress.updateAddress = false;
	}
	public loadPage() {
		if (this.dmvStoreService.registrationsInCart.firstIteration) {
			if (
				this.dmvStoreService.routeFrom &&
				this.dmvStoreService.routeFrom.from &&
				(this.dmvStoreService.routeFrom.from === "dmv-manual-renew" ||
					this.dmvStoreService.routeFrom.from === "dmv-duplicate")
			) {
				this.dmvStoreService.registrationsInCart.addressComefrom = "manual";
			}
		}
		//this.mailingAddress.countryCode = "US";
		this.dmvStoreService.registrationsInCart.pickupInPerson = undefined;
		this.globalService.supportKioskPickup = undefined;
		this.mailingAddress.updateAddressCheckBox = this.updateAddressCheckBox;
		this.mailingAddress.permAddressUpdate = this.permAddressUpdate;
		this.mailingAddress.tempAddressChange = this.tempAddressChange;
		this.dmvStoreService.registrationsInCart.mailingAddress = this.mailingAddress;
		this.dmvStoreService.registrationsInCart.firstIteration = false;
		//this.dmvStoreService.registrationsInCart.dmvRegistrations = this.dmvStoreService.registrationsInCart.dmvRegistrations.slice();
		if (this.dmvStoreService.registrationsInCart.dmvRegistrations) {
			this.dmvStoreService.registrationsInCart.dmvRegistrations = this.dmvStoreService.registrationsInCart.dmvRegistrations.slice();
		} else if (
			this.dmvStoreService.registrationsInCart.dmvRegistrationsManual
		) {
			this.dmvStoreService.registrationsInCart.dmvRegistrationsManual = this.dmvStoreService.registrationsInCart.dmvRegistrationsManual.slice();
		}
		AppUtil.log(
			"DmvPickupMailingComponent continue() == > this.mailingAddress ==",
			this.mailingAddress
		);
		this.router.navigate(["dmv-review-cart"], { skipLocationChange: true });
	}
	public updateAddressEvent(event, isUpdate) {
		AppUtil.log(
			"DmvPickupMailingComponent updateAddressEvent() == >",
			event,
			isUpdate
		);

		if (isUpdate) {
			this.pickupMailingForm.controls.notUpdateAddress.setValue(
				!event.target.checked
			);
			this.permAddressUpdate = true;
			this.tempAddressChange = false;
		} else {
			this.pickupMailingForm.controls.updateAddress.setValue(
				!event.target.checked
			);
			this.tempAddressChange = true;
			this.permAddressUpdate = false;
		}
	}
	public goBack() {
		AppUtil.log(
			"DmvPickupMailingComponent goBack() == >",
			this.dmvStoreService.routeFrom
		);
		if (
			this.dmvStoreService.routeFrom &&
			this.dmvStoreService.routeFrom.from &&
			this.dmvStoreService.routeFrom.from !== "dmv-manual-renew" &&
			this.dmvStoreService.routeFrom.from !== "dmv-duplicate" &&
			!this.agencyConfig.agencyDmvConfig.allowPickup
		) {
			this.router.navigate([this.dmvStoreService.routeFrom.from], {
				skipLocationChange: true
			});
		} else {
			if (this.agencyConfig.agencyDmvConfig.allowPickup) {
				this.router.navigate(["dmv-pickup-method"], {
					skipLocationChange: true
				});
			} else {
				if (
					this.dmvStoreService.routeFrom &&
					this.dmvStoreService.routeFrom.from === "dmv-review-cart"
				) {
					this.router.navigate(["dmv-review-cart"], {
						skipLocationChange: true
					});
				} else {
					this.router.navigate(["dmv-donation"], { skipLocationChange: true });
				}
			}
		}
	}
}
